/*(($, Drupal, once) => {
  Drupal.behaviors.cridfMasonryList = {
    attach: function attach(context) {
      once('cridfMasonryList', '.actualite-list__masonry', context).forEach((element) => {
        const list = $(element);
        const mountMasonry = () => {
          list.masonry({
            itemSelector: '.actualite-list__masonry--item',
            columnWidth: '.actualite-list__masonry--sizer',
            gutter: '.actualite-list__masonry--gutter',
            percentPosition: true,
            horizontalOrder: true,
          });
        };
        const unMountMasonry = () => list.masonry('destroy');
        const toggleMasonry = ({ matches }) => {
          if (matches) {
            unMountMasonry();
          } else {
            mountMasonry();
          }
        };
        const query = window.matchMedia('(max-width:575px');
        toggleMasonry(query);
        if (query.addEventListener) {
          query.addEventListener('change', toggleMasonry);
        } else {
          query.addListener(toggleMasonry);
        }
      });
    },
  };
})(jQuery, Drupal, once);*/


var msnry = new Masonry('.actualite-list__masonry', {
  itemSelector: '.actualite-list__masonry--item',
  percentPosition: true,
  columnWidth: '.actualite-list__masonry--sizer',
  gutter: '.actualite-list__masonry--gutter',
});

imagesLoaded('.actualite-list__masonry', function() {
  msnry.layout();
});
